import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";

export default function UserContextMenu({
  position,
  user,
  onViewProfile,
  onReport,
  onClose,
}) {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  // Función para abrir el chat con el usuario seleccionado
  const handleSendMessage = async (otherUser) => {
    if (!currentUser) return;

    try {
      let chatId = null;

      // 1️⃣ Buscar chat en "chats"
      const chatsRef = collection(db, "chats");
      const q = query(chatsRef, where("users", "array-contains", currentUser.uid));
      const chatsSnap = await getDocs(q);

      chatsSnap.forEach((chatDoc) => {
        const data = chatDoc.data();
        if (data.users.includes(otherUser.uid)) {
          chatId = chatDoc.id;
        }
      });

      // 2️⃣ Si no hay chat, buscar en "chatsPromotional"
      if (!chatId) {
        const chatsPromoRef = collection(db, "chatsPromotional");
        const qPromo = query(
          chatsPromoRef,
          where("users", "array-contains", currentUser.uid)
        );
        const chatsPromoSnap = await getDocs(qPromo);

        chatsPromoSnap.forEach((chatDoc) => {
          const data = chatDoc.data();
          if (data.users.includes(otherUser.uid)) {
            chatId = chatDoc.id;
          }
        });
      }

      // 3️⃣ Si sigue sin chat, crear chatId estilo user1_user2
      if (!chatId) {
        chatId =
          currentUser.uid < otherUser.uid
            ? `${currentUser.uid}_${otherUser.uid}`
            : `${otherUser.uid}_${currentUser.uid}`;
      }

      // 4️⃣ Navegar al chat
      navigate(`/chat/${chatId}`);
    } catch (error) {
      console.error("Error abriendo chat:", error);
    }
  };

  return (
    <div
      style={{
        position: "absolute",
        top: `${position.top}px`,
        left: `${position.left}px`,
        zIndex: 1000,
        width: "180px",
      }}
      className="text-sm animate-fade-in bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-md shadow-lg"
    >
      {/* Botón para ver el perfil del usuario */}
      <button
        className="block w-full text-left px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700"
        onClick={() => {
          onViewProfile(user);
          onClose();
        }}
      >
        Ver perfil
      </button>

      {/* Botón para abrir chat directo con el usuario */}
      <button
        className="block w-full text-left px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700"
        onClick={() => {
          handleSendMessage(user);
          onClose();
        }}
      >
        Enviar mensaje
      </button>

      {/* Botón para reportar al usuario */}
      <button
        className="block w-full text-left px-3 py-2 text-red-600 hover:bg-red-100 dark:hover:bg-red-900"
        onClick={() => {
          onReport(user);
          onClose();
        }}
      >
        Reportar
      </button>
    </div>
  );
}
